// export const API_BASE_URL = 'https://cms.coachgenie.in/API';
// export const APP_BASE_URL = 'https://cms.coachgenie.in';
// export const API_BASE_URL = 'https://report.webtrixsolutions.in/API';
// export const APP_BASE_URL = 'https://report.webtrixsolutions.in';
// export const API_BASE_URL = 'http://localhost/webtrix_24_BE';
export const APP_NAME = "Webtrix24 CRM";
export const API_BASE_URL = 'https://rental.webtrixsolutions.in/API';
export const APP_BASE_URL = 'https://rental.webtrixsolutions.in';

// export const API_BASE_URL = 'https://ankur.webtrixsolutions.in/admin/API';
// export const APP_BASE_URL = 'https://ankur.webtrixsolutions.in/admin';

// export const API_BASE_URL = "https://"+window.location.host+"/API";
// export const APP_BASE_URL = "https://"+window.location.host+"";
// export const API_BASE_URL = 'https://www.webtrix24.com/admin/API';
// export const APP_BASE_URL = 'https://www.webtrix24.com/admin';
export const APP_ID = '2318158991914536';
export const COMPANY_WHATSAPP_NUMBER = '15551457921';